<template>
	<div>
		<!--mobile-->
		<v-navigation-drawer
			v-model="drawer"
			color="accent"
			app
			temporary
			right
			width="100%"
			height="100%"
			disable-resize-watcher
		>
			<template slot="prepend">
				<v-toolbar flat class="accent px-md-15">
					<v-spacer />
					<v-icon color="white" @click="drawer = !drawer" class="pr-8">mdi-close</v-icon>
				</v-toolbar>

				<v-row justify="center">
					<div class="d-flex flex-column">
						<v-btn
							large
							outlined
							rounded
							color="white"
							dark
							href="https://pedidos.soladomingo.com/sldmg/identificar.asp"
							target="_blank"
						>
							<v-sheet class="pr-3 pt-1" color="transparent">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
									<g id="Grupo_4891" data-name="Grupo 4891" transform="translate(-6257 8156)">
										<g id="Grupo_4890" data-name="Grupo 4890">
											<g id="Grupo_4889" data-name="Grupo 4889">
												<g id="Icon" transform="translate(6257 -8156)">
													<rect id="Area" width="20" height="20" fill="#fcfcfc" opacity="0" />
													<g id="Icon-2" data-name="Icon" transform="translate(1.29 2.499)">
														<path
															id="Path"
															d="M2.5,1.667h15l1.346,5.744A5.509,5.509,0,0,1,17.5,9.679v6.988a1.666,1.666,0,0,1-1.667,1.666H4.167A1.666,1.666,0,0,1,2.5,16.667s.021-4.568,0-6.988A3.2,3.2,0,0,1,1.313,7.184Z"
															transform="translate(-1.29 -2.499)"
															fill="none"
															stroke="#fff"
															stroke-linecap="round"
															stroke-linejoin="round"
															stroke-width="1.667"
														/>
														<path
															id="Path-2"
															data-name="Path"
															d="M7.5,15.654V10h3.077v5.654"
															transform="translate(-0.249 0.18)"
															fill="none"
															stroke="#fff"
															stroke-linecap="round"
															stroke-linejoin="round"
															stroke-width="1.667"
														/>
														<g
															id="Trazado_59448"
															data-name="Trazado 59448"
															transform="translate(-0.29 1.84)"
															fill="none"
														>
															<path
																d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
																stroke="none"
															/>
															<path
																d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
																stroke="none"
																fill="#fff"
															/>
														</g>
														<g
															id="Trazado_59449"
															data-name="Trazado 59449"
															transform="translate(3.789 1.84)"
															fill="none"
														>
															<path
																d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
																stroke="none"
															/>
															<path
																d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
																stroke="none"
																fill="#fff"
															/>
														</g>
														<g
															id="Trazado_59450"
															data-name="Trazado 59450"
															transform="translate(7.789 1.84)"
															fill="none"
														>
															<path
																d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
																stroke="none"
															/>
															<path
																d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
																stroke="none"
																fill="#fff"
															/>
														</g>
														<g
															id="Trazado_59451"
															data-name="Trazado 59451"
															transform="translate(12.556 1.84)"
															fill="none"
														>
															<path
																d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
																stroke="none"
															/>
															<path
																d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
																stroke="none"
																fill="#fff"
															/>
														</g>
													</g>
												</g>
											</g>
										</g>
										<path
											id="Trazado_59452"
											data-name="Trazado 59452"
											d="M6262.451-8148.557l.4-5.5"
											fill="none"
											stroke="#fff"
											stroke-width="1"
										/>
										<path
											id="Trazado_59453"
											data-name="Trazado 59453"
											d="M6262.625-8148.6v-5.513"
											transform="translate(4)"
											fill="none"
											stroke="#fff"
											stroke-width="1"
										/>
										<path
											id="Trazado_59454"
											data-name="Trazado 59454"
											d="M6262.85-8148.557l-.4-5.5"
											transform="translate(8)"
											fill="none"
											stroke="#fff"
											stroke-width="1"
										/>
									</g>
								</svg>
							</v-sheet>
							{{ $t('nav.tienda') }}
						</v-btn>

						<v-btn
							large
							outlined
							rounded
							class="mt-3"
							color="white"
							dark
							href="https://order.soladomingo.com/"
							target="_blank"
						>
							<v-sheet class="pr-3 pt-1" color="transparent">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="14.752"
									height="15.593"
									viewBox="0 0 14.752 15.593"
								>
									<g id="Grupo_4893" data-name="Grupo 4893" transform="translate(-6259.624 8218.837)">
										<g id="Grupo_4892" data-name="Grupo 4892" transform="translate(6183.57 -8236.052)">
											<g id="Grupo_2251" data-name="Grupo 2251" transform="translate(76.854 18.013)">
												<path
													id="Unión_18"
													data-name="Unión 18"
													d="M-6257.008,8233.559a.8.8,0,0,1-.659-.772l-.149-7.819h-1.808a.8.8,0,0,1-.8-.8.8.8,0,0,1,.8-.8h1.874a6.021,6.021,0,0,1,1.773-3.595,6.028,6.028,0,0,1,4.244-1.734,6.067,6.067,0,0,1,6.061,6.061,6.064,6.064,0,0,1-6.042,6.061,5.279,5.279,0,0,1-.38,1.292,4.04,4.04,0,0,1-3.963,2.18A5.592,5.592,0,0,1-6257.008,8233.559Zm.926-1.529h.025a2.578,2.578,0,0,0,2.511-1.248,4.743,4.743,0,0,0,.339-1.533.8.8,0,0,1,.293-.554.81.81,0,0,1,.605-.171,4.542,4.542,0,0,0,.576.037,4.465,4.465,0,0,0,4.461-4.462,4.466,4.466,0,0,0-4.461-4.461,4.491,4.491,0,0,0-4.4,3.729h2.888v-.952a.8.8,0,0,1,.8-.8h.091a.8.8,0,0,1,.566.233l1.754,1.752a.8.8,0,0,1,0,1.133l-1.754,1.754a.8.8,0,0,1-.283.185.817.817,0,0,1-.374.093.8.8,0,0,1-.8-.8v-1h-2.972Z"
													transform="translate(6259.624 -8218.838)"
													fill="#fff"
												/>
											</g>
										</g>
									</g>
								</svg>
							</v-sheet>
							{{ $t('nav.pedidos') }}
						</v-btn>
					</div>
				</v-row>
				<v-divider class="mx-3 mt-5"></v-divider>
			</template>

			<v-container class="fill-height">
				<v-row align="center">
					<v-col align-self="center">
						<v-list class="py-2" dense v-for="item in menuItems" :key="item.title">
							<v-list-item class="py-0">
								<v-list-item-content class="py-0">
									<v-list-item-title class="d-flex justify-center py-0">
										<scroll-link
											:href="`${item.hash}`"
											class="coolink px-5 white--text display-1 font-weight"
										>
											<template v-if="$route.name === 'index'">
												<span @click="drawer = false">{{ $t(`${item.title}`) }}</span>
											</template>

											<template v-else>
												<span @click="inicioToHash">{{ $t(`${item.title}`) }}</span>
											</template>
										</scroll-link>
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-col>
				</v-row>
			</v-container>

			<template slot="append">
				<v-divider class="mx-3"></v-divider>
				<v-container>
					<v-row justify="center">
						<v-col cols="4">
							<div id="idiomas" class="d-flex justify-center">
								<v-select
									background-color="white"
									class="mb-15"
									hide-details="auto"
									dense
									outlined
									v-model="$i18n.locale"
									:items="langs"
									append-icon="mdi-chevron-down"
									append-outer-icon=""
								/>
							</div>
						</v-col>
						<v-col cols="6">
							<div class="d-flex justify-end">
								<a>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="32.29"
										height="41.036"
										viewBox="0 0 32.29 41.036"
									>
										<g id="Grupo_4948" data-name="Grupo 4948" transform="translate(-197.612 -3317.754)">
											<path
												id="Unión_19"
												data-name="Unión 19"
												d="M18.836,39.969l-6.892-2.137a1.3,1.3,0,0,1-.92-1.246V31.514l.131-.06,8.037-2.891a2.011,2.011,0,0,0,1.331-1.893l0-10.994h0v-.036h0a1.3,1.3,0,0,0-.915-1.209L12.1,12.1A4.762,4.762,0,0,0,9.2,12.13L2.665,14.291l-.432.125V10.6A1.306,1.306,0,0,1,3.926,9.351l5.84,1.809a.679.679,0,0,0,.88-.644V1.307a1.305,1.305,0,0,1,1.7-1.246l7.271,2.293A1.3,1.3,0,0,1,20.525,3.6v9.688a1.989,1.989,0,0,0,1.4,1.876L30.114,17.7A1.779,1.779,0,0,1,31.29,19.29V29.661A1.3,1.3,0,0,1,29.6,30.907l-8.4-2.6h0a.515.515,0,0,0-.669.486v0l0,9.929a1.3,1.3,0,0,1-1.69,1.246ZM9.023,31.711.918,29.2A1.3,1.3,0,0,1,0,27.952V15.639a.313.313,0,0,1,.406-.3l8.438,2.616A1.306,1.306,0,0,1,9.762,19.2V31.167a.57.57,0,0,1-.569.57A.578.578,0,0,1,9.023,31.711Z"
												transform="translate(198.112 3318.262)"
												fill="#fff"
												stroke="rgba(0,0,0,0)"
												stroke-miterlimit="10"
												stroke-width="1"
											/>
										</g>
									</svg>
								</a>
							</div>
							<span class="pb-0 d-flex justify-end">
								<p class="ma-0 amarillo--text">977 31 79 62</p>
							</span>
							<span class="pb-10 d-flex justify-end">
								<a href="mailto:ventas@soladomingo.com"
									><p class="amarillo--text">ventas@soladomingo.com</p></a
								>
							</span>
						</v-col>
					</v-row>
				</v-container>
			</template>
		</v-navigation-drawer>

		<!--desktop-->
		<v-app-bar fixed app color="accent" elevate-on-scroll>
			<v-toolbar flat class="accent">
				<v-toolbar-title class="pt-2">
					<a>
            <v-img
                class="w-100"
                max-width="75"
                src="@/assets/img/logo-neftys-white.svg"
                contain
            />
					</a>
				</v-toolbar-title>
				<v-spacer />
				<v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer">
					<v-icon color="white">mdi-menu</v-icon></v-app-bar-nav-icon
				>

				<div class="hidden-sm-and-down" v-for="item in menuItems" :key="item.title">
					<scroll-link :href="`${item.hash}`" class="coolink px-5 white--text text-subtitle-1 font-weight">
						<template v-if="$route.name === 'index'">
							<span>{{ $t(`${item.title}`) }}</span>
						</template>

						<template v-else>
							<span @click="inicioToHash">{{ $t(`${item.title}`) }}</span>
						</template>
					</scroll-link>
				</div>

				<div id="idiomas" class="hidden-sm-and-down">
					<v-select
						background-color="white"
						:dark="dark"
						class="ma-auto"
						hide-details
						dense
						outlined
						v-model="$i18n.locale"
						:items="langs"
						append-icon="mdi-chevron-down"
					/>
				</div>
				<v-divider class="azulBtn mx-3 hidden-sm-and-down" vertical></v-divider>
				<v-btn
					outlined
					rounded
					color="white"
					class="hidden-sm-and-down mr-3"
					href="https://pedidos.soladomingo.com/sldmg/identificar.asp"
					target="_blank"
				>
					<v-sheet class="pr-3 pt-1" color="transparent">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
							<g id="Grupo_4891" data-name="Grupo 4891" transform="translate(-6257 8156)">
								<g id="Grupo_4890" data-name="Grupo 4890">
									<g id="Grupo_4889" data-name="Grupo 4889">
										<g id="Icon" transform="translate(6257 -8156)">
											<rect id="Area" width="20" height="20" fill="#fcfcfc" opacity="0" />
											<g id="Icon-2" data-name="Icon" transform="translate(1.29 2.499)">
												<path
													id="Path"
													d="M2.5,1.667h15l1.346,5.744A5.509,5.509,0,0,1,17.5,9.679v6.988a1.666,1.666,0,0,1-1.667,1.666H4.167A1.666,1.666,0,0,1,2.5,16.667s.021-4.568,0-6.988A3.2,3.2,0,0,1,1.313,7.184Z"
													transform="translate(-1.29 -2.499)"
													fill="none"
													stroke="#fff"
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="1.667"
												/>
												<path
													id="Path-2"
													data-name="Path"
													d="M7.5,15.654V10h3.077v5.654"
													transform="translate(-0.249 0.18)"
													fill="none"
													stroke="#fff"
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="1.667"
												/>
												<g
													id="Trazado_59448"
													data-name="Trazado 59448"
													transform="translate(-0.29 1.84)"
													fill="none"
												>
													<path
														d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
														stroke="none"
													/>
													<path
														d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
														stroke="none"
														fill="#fff"
													/>
												</g>
												<g
													id="Trazado_59449"
													data-name="Trazado 59449"
													transform="translate(3.789 1.84)"
													fill="none"
												>
													<path
														d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
														stroke="none"
													/>
													<path
														d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
														stroke="none"
														fill="#fff"
													/>
												</g>
												<g
													id="Trazado_59450"
													data-name="Trazado 59450"
													transform="translate(7.789 1.84)"
													fill="none"
												>
													<path
														d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
														stroke="none"
													/>
													<path
														d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
														stroke="none"
														fill="#fff"
													/>
												</g>
												<g
													id="Trazado_59451"
													data-name="Trazado 59451"
													transform="translate(12.556 1.84)"
													fill="none"
												>
													<path
														d="M5,2.5C5,4.248,3.881,5.661,2.5,5.661S.111,4.325,0,2.5C1.693,2.5,3.649,2.464,5,2.5Z"
														stroke="none"
													/>
													<path
														d="M 3.479429960250854 3.48589563369751 C 2.933459997177124 3.48589563369751 2.339560031890869 3.490375518798828 1.765219926834106 3.494705677032471 C 1.58195686340332 3.496085166931152 1.396702766418457 3.497480869293213 1.211251735687256 3.4987473487854 C 1.474534511566162 4.208206176757812 1.948444604873657 4.661185264587402 2.5 4.661185264587402 C 3.068868160247803 4.661185264587402 3.575956583023071 4.177618980407715 3.829263925552368 3.486574649810791 C 3.71732759475708 3.48612117767334 3.600790023803711 3.48589563369751 3.479429960250854 3.48589563369751 M 3.47942590713501 2.485892295837402 C 4.032143592834473 2.485892295837402 4.549588203430176 2.490344047546387 5 2.503705501556396 C 5 4.247535705566406 3.880710124969482 5.661185264587402 2.5 5.661185264587402 C 1.119290113449097 5.661185264587402 0.1113300323486328 4.32480525970459 0 2.503705501556396 C 1.128524541854858 2.503705501556396 2.374192476272583 2.485892295837402 3.47942590713501 2.485892295837402 Z"
														stroke="none"
														fill="#fff"
													/>
												</g>
											</g>
										</g>
									</g>
								</g>
								<path
									id="Trazado_59452"
									data-name="Trazado 59452"
									d="M6262.451-8148.557l.4-5.5"
									fill="none"
									stroke="#fff"
									stroke-width="1"
								/>
								<path
									id="Trazado_59453"
									data-name="Trazado 59453"
									d="M6262.625-8148.6v-5.513"
									transform="translate(4)"
									fill="none"
									stroke="#fff"
									stroke-width="1"
								/>
								<path
									id="Trazado_59454"
									data-name="Trazado 59454"
									d="M6262.85-8148.557l-.4-5.5"
									transform="translate(8)"
									fill="none"
									stroke="#fff"
									stroke-width="1"
								/>
							</g>
						</svg>
					</v-sheet>
					{{ $t('nav.tienda') }}
				</v-btn>
				<v-btn
					class="hidden-sm-and-down"
					rounded
					outlined
					color="white"
					dark
					href="https://order.soladomingo.com/"
					target="_blank"
				>
					<v-sheet class="pr-3 pt-1" color="transparent">
						<svg xmlns="http://www.w3.org/2000/svg" width="14.752" height="15.593" viewBox="0 0 14.752 15.593">
							<g id="Grupo_4893" data-name="Grupo 4893" transform="translate(-6259.624 8218.837)">
								<g id="Grupo_4892" data-name="Grupo 4892" transform="translate(6183.57 -8236.052)">
									<g id="Grupo_2251" data-name="Grupo 2251" transform="translate(76.854 18.013)">
										<path
											id="Unión_18"
											data-name="Unión 18"
											d="M-6257.008,8233.559a.8.8,0,0,1-.659-.772l-.149-7.819h-1.808a.8.8,0,0,1-.8-.8.8.8,0,0,1,.8-.8h1.874a6.021,6.021,0,0,1,1.773-3.595,6.028,6.028,0,0,1,4.244-1.734,6.067,6.067,0,0,1,6.061,6.061,6.064,6.064,0,0,1-6.042,6.061,5.279,5.279,0,0,1-.38,1.292,4.04,4.04,0,0,1-3.963,2.18A5.592,5.592,0,0,1-6257.008,8233.559Zm.926-1.529h.025a2.578,2.578,0,0,0,2.511-1.248,4.743,4.743,0,0,0,.339-1.533.8.8,0,0,1,.293-.554.81.81,0,0,1,.605-.171,4.542,4.542,0,0,0,.576.037,4.465,4.465,0,0,0,4.461-4.462,4.466,4.466,0,0,0-4.461-4.461,4.491,4.491,0,0,0-4.4,3.729h2.888v-.952a.8.8,0,0,1,.8-.8h.091a.8.8,0,0,1,.566.233l1.754,1.752a.8.8,0,0,1,0,1.133l-1.754,1.754a.8.8,0,0,1-.283.185.817.817,0,0,1-.374.093.8.8,0,0,1-.8-.8v-1h-2.972Z"
											transform="translate(6259.624 -8218.838)"
											fill="#fff"
										/>
									</g>
								</g>
							</g>
						</svg>
					</v-sheet>
					{{ $t('nav.pedidos') }}
				</v-btn>
			</v-toolbar>
		</v-app-bar>
	</div>
</template>

<script>
import ScrollLink from './ScrollLink.vue';
export default {
	components: { ScrollLink },
	name: 'navigation',
	data: () => ({
		langs: ['ES', 'CA'],
		drawer: null,
		navigationScrollStart: true,
		// isXs: false,

		menuItems: [
			{
				path: '/',
				id: 'inicio-link',
				hash: '#inicio',
				name: 'inicio',
				title: 'nav.index',
			},
			{
				//path: "/nosotros",
				id: 'nosotros-link',
				hash: '#nosotros',
				name: 'nosotros',
				title: 'nav.nosotros',
			},
			{
				//path: "/nosotros",
				id: 'sectores-link',
				hash: '#sectores',
				name: 'sectores',
				title: 'nav.sectores',
			},
			{
				//path: "/servicios",
				id: 'servicios-link',
				hash: '#servicios',
				name: 'servicios',
				title: 'nav.servicios',
			},
			{
				//path: "/contacto",
				id: 'contacto-link',
				hash: '#contacto',
				name: 'contacto',
				title: 'nav.contacto',
			},
		],
		dark: false,
	}),

	methods: {
		inicio() {
			if (this.$route.name !== 'index') {
				this.$vuetify.goTo(0);
				this.$router.push('/');
			}
		},

		inicioToHash() {
			this.drawer = false;
			if (this.$route.name !== 'index') {
				this.$router.push('/');
			}
		},

		scroll(idtag) {
			this.drawer = false;
			const element = document.getElementById(idtag);
			element.scrollIntoView({ behavior: 'smooth' });
		},

		/* checkNavigation(hash) {
      if(this.navigationScrollStart) {
        // this.$refs[hash?.split?.('#')?.[1]].scrollTop = 0;
        this.navigationScrollStart = false;
      } else {
        this.$vuetify.goTo(hash);
      }
    } */
	},
};
</script>

<style scoped>
.coolink {
	padding: 5px 0px 5px;
	background-image: linear-gradient(currentColor, currentColor);
	background-position: 50% 100%;
	background-repeat: no-repeat;
	background-size: 0% 1px;
	transition: background-size 0.3s;
}

.coolink:hover,
.coolink:focus {
	background-size: 70% 1px;
}
.coolink.router-link-active,
.coolink.router-link-exact-active {
	background-size: 70% 1px;
}

#idiomas {
	width: 83px;
}

#logo {
	stroke-dasharray: 915;
	stroke-dashoffset: 915;
	animation: line-anim 2s ease forwards 0.3s;
}

@keyframes line-anim {
	to {
		stroke-dashoffset: 0;
	}
}
</style>
